import React, { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import './Auth.css';

const VerifyEmail = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const [resending, setResending] = useState(false);
  const [resendMessage, setResendMessage] = useState('');
  const [resendError, setResendError] = useState('');

  const email = location.state?.email || '';

  // Appliquer la langue passée depuis l'inscription
  useEffect(() => {
    const langue = location.state?.langue;
    if (langue && langue !== i18n.language) {
      i18n.changeLanguage(langue);
    }
  }, [location.state?.langue, i18n]);

  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

  const handleResendEmail = async () => {
    if (!email) {
      setResendError(t('verifyEmail.emailNotAvailable'));
      return;
    }

    setResending(true);
    setResendError('');
    setResendMessage('');

    try {
      const response = await axios.post(`${API_URL}/auth/resend-verification/`, {
        email: email,
      });
      setResendMessage(response.data.message || t('verifyEmail.resendSuccess'));
    } catch (error) {
      setResendError(
        error.response?.data?.error ||
        error.response?.data?.message ||
        t('verifyEmail.resendError')
      );
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-main auth-main-no-nav">
        <div className="auth-content-wrapper">
          <div className="auth-card">
            <div style={{ textAlign: 'center', marginBottom: '30px' }}>
              <div style={{ fontSize: '64px', marginBottom: '20px' }}>📧</div>
              <h1 style={{ color: '#333', marginBottom: '15px' }}>
                {t('verifyEmail.title')}
              </h1>
              <p style={{ color: '#666', fontSize: '16px', lineHeight: '1.6' }}>
                {t('verifyEmail.sentTo')}
              </p>
              {email && (
                <p style={{ color: '#667eea', fontWeight: '600', marginTop: '10px', fontSize: '18px' }}>
                  {email}
                </p>
              )}
            </div>

            <div style={{
              background: '#f0f7ff',
              border: '1px solid #cce5ff',
              borderRadius: '8px',
              padding: '20px',
              marginBottom: '30px'
            }}>
              <h3 style={{ color: '#333', marginBottom: '15px', fontSize: '18px' }}>
                {t('verifyEmail.steps')}
              </h3>
              <ol style={{ color: '#555', lineHeight: '1.8', paddingLeft: '20px' }}>
                <li>{t('verifyEmail.step1')}</li>
                <li>{t('verifyEmail.step2')}</li>
                <li>{t('verifyEmail.step3')}</li>
              </ol>
            </div>

            {resendMessage && (
              <div style={{
                background: '#d4edda',
                color: '#155724',
                padding: '12px',
                borderRadius: '5px',
                marginBottom: '20px',
                border: '1px solid #c3e6cb'
              }}>
                {resendMessage}
              </div>
            )}

            {resendError && (
              <div style={{
                background: '#fee',
                color: '#c33',
                padding: '12px',
                borderRadius: '5px',
                marginBottom: '20px',
                border: '1px solid #fcc'
              }}>
                {resendError}
              </div>
            )}

            {email && (
              <button
                onClick={handleResendEmail}
                disabled={resending}
                style={{
                  width: '100%',
                  padding: '12px',
                  background: 'transparent',
                  color: '#667eea',
                  border: '2px solid #667eea',
                  borderRadius: '5px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: resending ? 'not-allowed' : 'pointer',
                  opacity: resending ? 0.6 : 1,
                  marginBottom: '20px',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => {
                  if (!resending) {
                    e.target.style.background = '#667eea';
                    e.target.style.color = 'white';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!resending) {
                    e.target.style.background = 'transparent';
                    e.target.style.color = '#667eea';
                  }
                }}
              >
                {resending ? t('verifyEmail.sending') : t('verifyEmail.resend')}
              </button>
            )}

            <div style={{ textAlign: 'center', marginTop: '30px' }}>
              <p style={{ color: '#666', marginBottom: '10px' }}>
                {t('verifyEmail.afterVerify')}
              </p>
              <Link
                to="/login"
                style={{
                  color: '#667eea',
                  textDecoration: 'none',
                  fontWeight: '600',
                  fontSize: '16px'
                }}
              >
                {t('verifyEmail.goToLogin')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
